export const MENUS_QUERY_KEY = "menus/";

export type MenuTargetKind = "route" | "page" | "external" | null;
export type MenuOpenIn = "same_tab" | "new_tab" | "iframe";

export type MenuItem = {
  id: number;
  title: string;
  order: number;
  targetKind: MenuTargetKind;
  href: string | null;
  openIn: MenuOpenIn;
  children: MenuItem[];
};

export type Menu = {
  slug: string;
  items: MenuItem[];
};
